import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/Homepage.css";
import Navbar from "../pages/Navbar";
import Footer from "../pages/Footer";
import aboutlap from "./Homepage/Images/aboutlap.svg";


const RefundPolicy = () => {
  return (
    <div>
      <Navbar />
      <div className="about-banner">
        <h2>Refund Policy</h2>
        <p>
          Our Refund Policy outlines the terms and conditions under which refunds may be issued for our products and services. We strive to ensure customer satisfaction and handle refund requests in a fair and transparent manner. If you are not satisfied with your purchase or experience any issues, please review our policy below and contact us for assistance. We reserve the right to update this policy at any time, so please check this page regularly for changes.
        </p>
      </div>
     
      <div className="about-white-line">
        <div className="about-des container pt-5">
            <h3>Key Points of Our Refund Policy</h3>
            <p>
              Please note the following important aspects regarding refunds:
            </p>
            <ul>
              <li>Refund requests must be submitted within the specified period after purchase.</li>
              <li>Eligibility for a refund depends on the nature of the product or service and the reason for the request.</li>
              <li>We may require proof of purchase or additional information to process your request.</li>
              <li>Approved refunds will be processed using the original payment method.</li>
              <li>Some products or services may be non-refundable as specified at the time of purchase.</li>
            </ul>
        </div>
        <div className="about-location py-5">
            <div className="about-des-location container mx-auto">
            <h3>Our Location</h3>
            <p>Shop No. 203 II Floor, Hiltan Arcade Shopping Center, Evershine CityGokhivare,  Vasai East, Vasai, Mumbai - 401208.</p>
            </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RefundPolicy;
